// first 4 ones is visible

export const poiTypes = [
  {
    id: 11,
    name: "Ulaşım",
    placemarkImageHref: "/assets/icons/map/poi-placemark-icon/ulasim.svg",
  },
  {
    id: 7,
    name: "Marketler",
    placemarkImageHref: "/assets/icons/map/poi-placemark-icon/marketler.svg",
  },
  {
    id: 8,
    name: "Sağlık Kurumları",
    placemarkImageHref: "/assets/icons/map/poi-placemark-icon/saglik_kurumlari.svg",
  },
  {
    id: 5,
    name: "Kafe/Restoranlar",
    placemarkImageHref: "/assets/icons/map/poi-placemark-icon/kafe.svg",
  },
  {
    id: 2,
    name: "Eğitim Kurumları",
    placemarkImageHref: "/assets/icons/map/poi-placemark-icon/egitim_kurumlari.svg",
  },
  {
    id: 1,
    name: "Alışveriş Merkezleri",
    placemarkImageHref: "/assets/icons/map/poi-placemark-icon/alisveris.svg",
  },
  {
    id: 3,
    name: "Eğlence Yerleri",
    placemarkImageHref: "/assets/icons/map/poi-placemark-icon/eglence.svg",
  },
  {
    id: 4,
    name: "Dini Yerler",
    placemarkImageHref: "/assets/icons/map/poi-placemark-icon/dini_yerler.svg",
  },
  {
    id: 6,
    name: "Kültürel Aktiviteler",
    placemarkImageHref: "/assets/icons/map/poi-placemark-icon/kulturel_yerler.svg",
  },
  {
    id: 9,
    name: "Spor Tesisleri",
    placemarkImageHref: "/assets/icons/map/poi-placemark-icon/spor.svg",
  },
  {
    id: 10,
    name: "Tarihi/Turistik Yerler",
    placemarkImageHref: "/assets/icons/map/poi-placemark-icon/tarihi_yerler.svg",
  },
];

export const getGa4EventForPoiId = {
  11: "ulasim",
  7: "marketler",
  8: "saglik-kurumlari",
  5: "kafeler-restoranlar",
  2: "egitim-kurumlari",
  1: "alisveris-merkezleri",
  3: "eglence-yerleri",
  4: "dini-merkezler",
  6: "kulturel-aktiviteler",
  9: "spor-tesisleri",
  10: "tarihi-turistik-yerler",
};

export default {};
